//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import CurrencyPairs from '~/views/Markets/MarketsCurrencyPairs/MarketsCurrencyPairs.vue';

export default {
  components: {
    CurrencyPairs,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadTradingOptionsAction(),
      this.getCurrenciesInUse(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('currencies', ['getCurrenciesInUse']),
    ...mapActions('marketsCurrencyPairs', {
      loadMarketsCurrencyPairs: 'loadData',
      loadTradingOptionsAction: 'loadTradingOptions',
    }),
  },
};
